<template>
  <MainLayout />
</template>

<script setup lang="ts">
import MainLayout from "@/layouts/MainLayout.vue";
</script>
